<div class="box-management mt-3" *ngIf="(superBidConfigurations && vehicle.status == 'ACTIVE' || vehicle.status == 'INACTIVE') && selectedSuperBidConfiguration">
    <form [formGroup]="form" style="width: 100%;">
        <div class="row">
            <div class="col-12 card-option-title align-items-center mb-3">
                <img alt="home-button" src="https://www.superbid.net/images/navbar/homepressed.svg" loading="lazy">
                Gerenciamento Superbid
            </div>

            <div class="col-md-12">
                <mat-form-field>
                    <mat-label>ID do evento</mat-label>
                    <mat-select name="superBidConfiguration" (selectionChange)="selectSuperBidConfiguration($event)"
                        formControlName="eventId">
                        <mat-option *ngFor="let superBidConfiguration of superBidConfigurations"
                            [value]="superBidConfiguration.eventId">
                            {{ superBidConfiguration.eventId }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>ID da oferta</mat-label>
                    <input matInput formControlName="offerId" />
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>ID do produto</mat-label>
                    <input matInput formControlName="productId" />
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Número de lote</mat-label>
                    <input matInput formControlName="lotNumber" />
                </mat-form-field>
            </div>
            <div class="col-6" *ngIf="selectSuperBidConfiguration">
                <mat-form-field floatLabel="always">
                    <mat-label>Grupo de oferta</mat-label>
                    <mat-select formControlName="groupOfferId">
                        <mat-option *ngFor="let groupOffer of selectedSuperBidConfiguration.allEventsGroups"
                          [value]="groupOffer.id">
                          {{ groupOffer.name }}
                        </mat-option>
                      </mat-select>              
                </mat-form-field>
            </div>
            <div class="col-12 ignore-personalized-offers" *ngIf="vehicle.superBidAvailableToFinancing">
                <mat-checkbox formControlName="enableFinancing">Disponibilizar financiamento</mat-checkbox>
            </div>
            <div class="col-12 ignore-personalized-offers mb-3" *ngIf="!isOfferActive">
                <mat-checkbox [(ngModel)]="includeSubLot" [ngModelOptions]="{standalone: true}">Incluir número de sublote</mat-checkbox>
            </div>
            <div class="col-12" *ngIf="includeSubLot">
                <mat-form-field floatLabel="always">
                    <mat-label>Número do sublote</mat-label>
                    <input matInput formControlName="subLotNumber" />
                </mat-form-field>
            </div>
            <div class="col-12 save-auction-button">
                <button class="btn btn-primary btn-block btn-rounded" type="button" disabled *ngIf="uptadingOffer">
                    Aguarde...
                </button>
                <button class="btn btn-primary btn-block btn-rounded" type="button" (click)="publishSuperBidOffer()" *ngIf="!isOfferActive && !uptadingOffer">
                    Publicar oferta na Superbid
                </button>
                <!-- <button class="btn btn-primary btn-block btn-rounded" type="button" (click)="markAsSoldSuperBidOffer()" *ngIf="isOfferActive && !uptadingOffer">
                    Marcar como vendido na Superbid
                </button> -->
                <button class="btn btn-danger btn-rounded" type="button" (click)="cancelSuperBidOffer()" *ngIf="isOfferActive && !uptadingOffer">
                    Despublicar oferta na Superbid
                </button>
            </div>
        </div>
    </form>
</div>